import { render, staticRenderFns } from "./processt.vue?vue&type=template&id=36b1111b&scoped=true&"
import script from "./processt.vue?vue&type=script&lang=js&"
export * from "./processt.vue?vue&type=script&lang=js&"
import style0 from "./processt.vue?vue&type=style&index=0&id=36b1111b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1111b",
  null
  
)

export default component.exports